import { atom, selector } from "recoil";
import { createDataRequest, updateDataRequest } from "../../../api/controller/AnswerController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const answerListState = atom({
    key: 'answerListState',
    default: [],
})
export const answerQuestionState = atom({
	key: 'answerQuestionState',
	default:{
		data:[],
		ovf:false,
	}
})
export const answerQuizState = atom({
	key: 'answerQuizState',
	default:{
		data:[],
		ovf:false,
	}
})

export const modalConfigDefault = { size: "lg", wizard: false }

export const filterAnswerQuizState = atom({
    key: 'filterAnswerQuizState',
    default: '',
})

export const filterAnswerQuestionState = atom({
    key: 'filterAnswerQuestionState',
    default: '',
})

export const answerFilterState = selector({
    key: 'answerFilterState',
    get: ({ get }) => (
        [
            {
                label: 'Quiz',
                size: 4,
                required: true,
                type: 'select',
                value: get(filterAnswerQuizState),
                list: get(answerQuizState),
                isParent: true,
            },
            {
                label: 'Question',
                size: 8,
                required: true,
                type: 'select',
                value: get(filterAnswerQuestionState),
                list: get(answerQuestionState),
                // onChange: (e,type) => set(filterAnswerQuestionState, (type === "select" ? e.value : (type === "dateRange" ? e.split(" to ") : e)))
            }
        ]
    ),
    set: ({ set }, e) => {
        if(e.filterLabel === 'Quiz'){
            set(filterAnswerQuizState, e)
        } else if (e.filterLabel === 'Question'){
            set(filterAnswerQuestionState, e)
        }
    }
})

export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest } ],
    view: [ { name: 'Default View' } ],
}

export const answerDataStructureState = selector({
    key: 'answerDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'Question',
                type: 'select',
                order: { table: 1, form: 1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: get(answerQuestionState),
            },
            { 
                label: 'User',
                type: 'text',
                field: 'user.display_name',
                order: { table: 1.1, form: 1.1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Question Description',
                field: 'question.description',
                type: 'text',
                order: { table: 2, form: 2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Question Image',
                field: 'question.image',
                type: 'file',
                order: { form: 3 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Given Answer',
                field: 'question_option.description',
                type: 'text',
                order: { table: 4, form: 4 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Given Answer Image',
                field: 'question_option.image',
                type: 'file',
                order: { form: 5 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Correct Image',
                field: 'question.correct_image',
                type: 'file',
                order: { form: 6 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Is Correct',
                field: 'question_option.is_correct',
                type: 'switch',
                order: { table: 7, form: 7 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            }

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
